const FilePreviewModal = ({ url, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50" onClick={onClose}>
    <div className="bg-white rounded-lg p-4 m-4 mt-8 max-w-5xl w-full h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
      <button onClick={onClose} className="self-end">✖</button>
      <div className="flex-1 flex items-center justify-center overflow-auto">
        <img src={url} alt="Preview" className="max-w-full max-h-full object-contain" />
      </div>
    </div>
  </div>
);

export default FilePreviewModal;
